function formatDateISO(date: string, type?: 'invert'): string {
  if (!date) return '';

  const isoDate = new Date(date);

  const day = String(isoDate.getDate()).padStart(2, '0');
  const month = String(isoDate.getMonth() + 1).padStart(2, '0');
  const year = isoDate.getFullYear();

  if (!type) {
    return `${day}/${month}/${year}`;
  }

  return `${year}-${month}-${day}`;
}

export default formatDateISO;
